import { Button, Tag, Typography } from 'antd';
import { PAYOUT_REPORT_STATUS } from 'constants/status';
import { EyeOutlined } from '@ant-design/icons';
import { InvoiceIconSvgIcon } from 'utils/icons';
import dayjs from 'dayjs';
import currencyFormat from 'utils/currencyFormat';

const columnStyles = {
  fontWeight: 700,
  fontSize: '14px',
  textAlign: 'center',
  width: '100%',
  whiteSpace: 'nowrap'
};

const textStyle = {
  fontSize: '14px',
  width: '100%'
};

const getCustomBasedPayoutReport = (handleViewDetails, handleUploadInvoice, downloadInvoice) => {
  /* eslint-disable camelcase */

  return [
    {
      title: <Typography.Text style={columnStyles}>Payout ID</Typography.Text>,
      dataIndex: 'payout_id',
      key: 'payout_id',
      width: 60,
      fixed: 'left',
      render: (payout_id) => {
        return <Typography.Text style={textStyle}>{payout_id}</Typography.Text>;
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Reporting Duration</Typography.Text>,
      dataIndex: 'payout_month_report',
      key: 'payout_month_report',
      width: 120,
      render: (_, record) => {
        const payoutStartMonth = record?.payout_start_date;
        const payoutEndMonth = record?.payout_end_date;

        const startOfMonth = payoutStartMonth ? dayjs(payoutStartMonth).format('DD/MM/YYYY') : null;

        const endOfMonth = payoutEndMonth ? dayjs(payoutEndMonth).format('DD/MM/YYYY') : null;

        return (
          <Typography.Text style={textStyle}>
            {startOfMonth} - {endOfMonth}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Commission (₹)</Typography.Text>,
      dataIndex: 'commission_amount',
      key: 'commission_amount',
      width: 100,
      render: (commission_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(commission_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>TDS (₹)</Typography.Text>,
      dataIndex: 'tds_amount',
      key: 'tds_amount',
      width: 100,
      render: (tds_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(tds_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>GST (₹)</Typography.Text>,
      dataIndex: 'gst_amount',
      key: 'gst_amount',
      width: 100,
      render: (gst_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(gst_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Invoice (₹)</Typography.Text>,
      dataIndex: 'invoice_amount',
      key: 'invoice_amount',
      width: 100,
      render: (invoice_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(invoice_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Status</Typography.Text>,
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => {
        return (
          <Typography.Text style={textStyle}>
            {' '}
            <Tag
              color={PAYOUT_REPORT_STATUS[status]?.bgColor}
              style={{
                padding: '2px 13px',
                color: PAYOUT_REPORT_STATUS[status]?.color,
                fontSize: '14px'
              }}
            >
              {PAYOUT_REPORT_STATUS[status]?.label}
            </Tag>
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Actions</Typography.Text>,
      fixed: 'right',
      align: 'center',
      width: 100,
      render: (record) => {
        const canUploadInvoice = record?.can_upload_invoice;
        const canDownloadInvoice = record?.invoice_status === 'PARTNER_INVOICE_UPLOADED';
        return (
          /* eslint-disable no-underscore-dangle */
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
            <Button
              size="medimum"
              style={
                canUploadInvoice
                  ? {
                      borderColor: 'var(--color-primary)',
                      cursor: 'pointer'
                    }
                  : { cursor: 'not-allowed' }
              }
              onClick={() => handleUploadInvoice(record._id)}
              type="primary"
              disabled={!canUploadInvoice}
            >
              Upload Invoice
            </Button>
            <Button
              size="medimum"
              style={
                canDownloadInvoice
                  ? {
                      borderColor: 'var(--color-primary)',
                      cursor: 'pointer'
                    }
                  : { cursor: 'not-allowed' }
              }
              onClick={() => downloadInvoice(record?.invoice_id, 'partner_invoice_url')}
              disabled={!canDownloadInvoice}
              icon={
                <InvoiceIconSvgIcon
                  style={
                    canDownloadInvoice
                      ? {
                          color: 'var(--color-primary)',
                          cursor: 'pointer'
                        }
                      : { cursor: 'not-allowed' }
                  }
                />
              }
            />
            <Button
              size="medimum"
              style={{ borderColor: 'var(--color-primary)' }}
              icon={
                <EyeOutlined
                  style={{ color: 'var(--color-primary)' }}
                  onClick={() => handleViewDetails(record)}
                />
              }
            />
          </div>
        );
      }
    }
  ];
};

const CustomReportStatus = [
  {
    label: 'Invoice Pending',
    value: 'PARTNER_AWAITING'
  },
  {
    label: 'Hold',
    value: 'INVOICE_ON_HOLD'
  },
  {
    label: 'Paid',
    value: 'PAID'
  },
  {
    label: 'Advance Paid',
    value: 'ADVANCE_PAID'
  },
  {
    label: 'Processing',
    value: 'PROCESSING'
  }
];

const CustomSearchArr = [
  {
    value: '_id',
    label: 'Payout Id'
  }
];

const CustomPayoutReportfiltersArr = [
  {
    attr: 'status',
    label: 'Status',
    data: CustomReportStatus
  }
];

//  while invoice upload add the loading
export { getCustomBasedPayoutReport, CustomPayoutReportfiltersArr, CustomSearchArr };
